import React, { Fragment } from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { AssetUnitsMaster } from '../../../types/project';
import IconButton from '@mui/material/IconButton/IconButton';
import EditSharpIcon from '@mui/icons-material/EditSharp';
import DeleteSharpIcon from '@mui/icons-material/DeleteSharp';
interface UnitsTableProps {
  rows: AssetUnitsMaster[];
  onDelete: (AssetGroupID: string, AssetTypeID: string) => void;
  handleEditClick: (AssetGroupID: string, AssetTypeID: string) => void;
  isEditable?: () => boolean;
}

const getSuffixes = (Suffixes) => {
  const suffixes = Suffixes.map((suffix) => suffix.SuffixName || 'N/A');

  const filteredSuffixes = suffixes.filter((suffix) => suffix !== 'N/A');

  return filteredSuffixes.length > 0
    ? filteredSuffixes.sort().join(', ')
    : suffixes.sort().join(', ');
};

const UnitsTable: React.FC<UnitsTableProps> = ({
  rows,
  onDelete,
  handleEditClick,
  isEditable,
}) => {
  if (rows.length === 0) return null;

  const renderActions = (AssetGroupID, AssetTypeID) => {
    return (
      <Fragment>
        {isEditable && isEditable() && (
          <Fragment>
            {/* <IconButton>
              <EditSharpIcon
                onClick={() => handleEditClick(AssetGroupID, AssetTypeID)}
              />
            </IconButton> */}
            <IconButton onClick={() => onDelete(AssetGroupID, AssetTypeID)}>
              <DeleteSharpIcon />
            </IconButton>
          </Fragment>
        )}
      </Fragment>
    );
  };

  rows.sort((a, b) => {
    // handle possible undefined values
    if (!a.AssetGroupType && !b.AssetGroupType) return 0;
    if (!a.AssetGroupType) return -1;
    if (!b.AssetGroupType) return 1;
    if (!a.AssetTypes && !b.AssetTypes) return 0;
    if (!a.AssetTypes) return -1;
    if (!b.AssetTypes) return 1;
    if (a.AssetGroupType < b.AssetGroupType) return -1;
    if (a.AssetGroupType > b.AssetGroupType) return 1;
    if (a.AssetGroupType === b.AssetGroupType) {
      //@ts-ignore
      if (a.AssetTypes[0].AssetName < b.AssetTypes[0].AssetName) return -1;
      //@ts-ignore
      if (a.AssetTypes[0].AssetName > b.AssetTypes[0].AssetName) return 1;
    }
    console.log('SORTED');
    return 0;
  });

  return (
    <Grid container sx={{ mx: 2, px: 2, minHeight: '50vh' }}>
      <TableContainer
        component={Paper}
        sx={{
          mx: 2,
          px: 2,
        }}
      >
        <Table size='small' stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontSize: 'large' }}>Category</TableCell>
              <TableCell sx={{ fontSize: 'large' }} align='left'>
                Unit Type
              </TableCell>
              {/* <TableCell sx={{ fontSize: "large" }} align="left">
                Suffix
              </TableCell> */}
              <TableCell sx={{ fontSize: 'large' }} align='right'>
                Action
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map(({ AssetGroupType, AssetGroupID, AssetTypes }) => (
              <Fragment>
                {AssetTypes && AssetTypes.length > 0 && (
                  <TableRow key={AssetGroupID}>
                    <TableCell rowSpan={AssetTypes.length + 1}>
                      {AssetGroupType}
                    </TableCell>
                  </TableRow>
                )}
                {AssetTypes &&
                  AssetTypes.map((assetType) => (
                    <Fragment>
                      <TableRow
                        style={{
                          backgroundColor: assetType.isDeleted
                            ? 'whitesmoke'
                            : '',
                        }}
                        key={assetType.AssetTypeID}
                      >
                        <TableCell align='left'>
                          {assetType.AssetName}
                        </TableCell>
                        {/* <TableCell align="left">
                          {getSuffixes(assetType.Suffixes)}
                        </TableCell> */}
                        <TableCell align='right'>
                          {renderActions(AssetGroupID, assetType.AssetTypeID)}
                        </TableCell>
                      </TableRow>
                    </Fragment>
                  ))}
              </Fragment>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Grid>
  );
};

export default UnitsTable;
